var validateEmail = require('../common/validate-email');
var validateTextField = require('../common/validate-textfield');
var recaptcha = require('../common/recaptcha');

module.exports = {
	init: function () {
		if (window.jQuery('#reset-password').length > 0) {
			window.jQuery('#reset-password').on('submit', validateForm);

			//reset validation marker on change
			window.jQuery('#email').on('change keyup', () => {
				window.jQuery('#email').removeClass('emailIsValid');
			});
		}
	}
};

const resumeSubmit = (token) => {
	window.jQuery('#reset-password').submit();
};

const validateForm = (e) => {
	var error = false;
	error = validateTextField('#email') || error;
	if (error) {
		return false;
	}

	const $submit = window.jQuery('#reset-password button[type=submit]');
	const emailIsValid = validateEmail('#email', 'emailIsValid', '#reset-password', $submit);

	if (!emailIsValid) {
		console.log('resetting recaptcha');
		recaptcha.reset();
		return false;
	} else {
		if (recaptcha.getToken() === '') {
			//the argument tells it to re-run this function once recaptcha execution completes
			console.log('sending captcha request');
			recaptcha.execute(resumeSubmit);
			return false;
		} else {
			//captcha complete, resume submit
			console.log('captcha request happy');
			return true;
		}
	}
};
